var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShipped(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mdi:courier-fast",
    clipPath: "url(#clip0_794_20033)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M1.75016 7.87516L1.31266 7.00016H4.37516L4.02516 6.12516H1.16683L0.729329 5.25016H5.27933L4.92933 4.37516H0.647663L0.145996 3.50016H2.3335C2.3335 3.19074 2.45641 2.894 2.6752 2.6752C2.894 2.45641 3.19074 2.3335 3.50016 2.3335H10.5002V4.66683H12.2502L14.0002 7.00016V9.91683H12.8335C12.8335 10.381 12.6491 10.8261 12.3209 11.1543C11.9927 11.4825 11.5476 11.6668 11.0835 11.6668C10.6194 11.6668 10.1742 11.4825 9.84606 11.1543C9.51787 10.8261 9.3335 10.381 9.3335 9.91683H7.00016C7.00016 10.381 6.81579 10.8261 6.4876 11.1543C6.15941 11.4825 5.71429 11.6668 5.25016 11.6668C4.78603 11.6668 4.34091 11.4825 4.01273 11.1543C3.68454 10.8261 3.50016 10.381 3.50016 9.91683H2.3335V7.87516H1.75016ZM11.0835 10.7918C11.3156 10.7918 11.5381 10.6996 11.7022 10.5355C11.8663 10.3715 11.9585 10.1489 11.9585 9.91683C11.9585 9.68476 11.8663 9.4622 11.7022 9.29811C11.5381 9.13402 11.3156 9.04183 11.0835 9.04183C10.8514 9.04183 10.6289 9.13402 10.4648 9.29811C10.3007 9.4622 10.2085 9.68476 10.2085 9.91683C10.2085 10.1489 10.3007 10.3715 10.4648 10.5355C10.6289 10.6996 10.8514 10.7918 11.0835 10.7918ZM11.9585 5.54183H10.5002V7.00016H13.1018L11.9585 5.54183ZM5.25016 10.7918C5.48223 10.7918 5.70479 10.6996 5.86888 10.5355C6.03298 10.3715 6.12516 10.1489 6.12516 9.91683C6.12516 9.68476 6.03298 9.4622 5.86888 9.29811C5.70479 9.13402 5.48223 9.04183 5.25016 9.04183C5.0181 9.04183 4.79554 9.13402 4.63144 9.29811C4.46735 9.4622 4.37516 9.68476 4.37516 9.91683C4.37516 10.1489 4.46735 10.3715 4.63144 10.5355C4.79554 10.6996 5.0181 10.7918 5.25016 10.7918Z",
    fill: "#242424"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_794_20033"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShipped);
export default __webpack_public_path__ + "static/media/shipped.7c9ba38dd4a51377854e7c69dd030047.svg";
export { ForwardRef as ReactComponent };